import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/store/auth";

function Spinner() {
  return (
    <div className="grid min-h-screen place-items-center bg-cream">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-navy-100 border-t-navy-800" />
    </div>
  );
}

/** Guards the admin dashboard: unauthenticated (or non-admin) -> /login. */
export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  if (status === "loading" || status === "idle") return <Spinner />;
  if (status === "unauthenticated") return <Navigate to="/login" replace />;

  return <>{children}</>;
}

export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  if (status === "loading" || status === "idle") return <Spinner />;
  if (status === "authenticated") return <Navigate to="/" replace />;

  return <>{children}</>;
}
